import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import {PartMenuType} from "../../constants";
import Config from "../../../../config";

import Filters from "../newFilters/filters";
import * as actions from "../../../../actions/actionFunctions";
import OnScreenKeyboard from "../../../common/OnScreenKeyboard/keyboard";
import {getFeatureGroupName, getPartThemeThumbnail} from "../../../../misc/helpers";
import {getSideBarSubParts} from "../navUtils";
import $ from "jquery";
import ActionTypes from "../../../../misc/actionTypes";

class SidebarClass extends Component {

  static propTypes = {
    part: PropTypes.object,
    onBackClick: PropTypes.func.isRequired,
    onSubTypeClick: PropTypes.func.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    onSubPartClick: PropTypes.func.isRequired,
    onSubPartHover: PropTypes.func.isRequired,
    activeChildNavigationItem: PropTypes.object,
    updateSidebarItems: PropTypes.bool
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.updateSidebarItems) {
      this.forceUpdate();
    }
  }

  handleRefresh = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
  }
  componentWillUnmount() {
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
  }

  getSideBarContent = () => {
    const {part, onSubPartClick, onSubPartHover, activeChildNavigationItem, activeNavigationFilter, activeTheme} = this.props;
    if (part.menuType === PartMenuType.Simple) {
      return <div className="customize-img" style={{backgroundImage: `url(${getPartThemeThumbnail(part.partThumbnail, activeTheme)})`}}/>
    } else if (activeChildNavigationItem && activeChildNavigationItem.part.partId === "top_cabinet"
      && activeNavigationFilter === "inlay_type") {
      return <div className="customize-img customize-img--inlay_type"/>
    }
    const subParts = getSideBarSubParts(part);
    return (
      <ul className={"customize-list" + (!part.subTypes().length ? " customize-list--full" : "")}>
        {subParts.map((dni, dniIndex) => {
          // if (name === "Island Countertop") {
          //   name = "Countertop"
          // }
          return (
            <li className={"customize-list__item"
            + (activeChildNavigationItem && (activeChildNavigationItem.text === dni.text) ? " customize-list__item--active" : "")
            + (Config.isDevMode() && dni.part.disabled ? " customize-list__item--disabled" : "")
            + (Config.isDevMode() && dni.part.canBeDisabled ? " customize-list__item--canBeDisabled" : "")
            }
                onMouseOver={() => onSubPartHover(dni)}
                key={dni.text}
                data-index={dniIndex}
                data-text={dni.text}
                onClick={() => onSubPartClick(dni)}>
              {getFeatureGroupName(dni.part, this.props.intl, this.props.fabricatorData)}
            </li>
          )
        })}
      </ul>
    )
  };

  render() {

    const {onBackClick, searchText, handleSearchInputChange, intl} = this.props;

    return (
      <div className="design-cell design-cell--left">
        <div className="customize">
          <div className="customize-top">
            <div className="customize-top__cell">
              <input className={"search-input"
              + (this.props.searchText ? " search-input--no-icon" : "")
              + (searchText && searchText.length > 12 ? " search-input--with-close" : "")
              }
                     value={searchText}
                     onChange={handleSearchInputChange}
                     placeholder={intl.formatMessage({id: "mobileMenu.searchPlaceholder"})}
                     id="main-search" />
              {searchText ? <button className={"ui-close search-close"}
                                    onClick={() => handleSearchInputChange({target:{value: ""}})}/> : null}
              <OnScreenKeyboard inputId="main-search" setValue={(v) => this.props.handleSearchInputChange({target: {value: v}})} type="text" top="40px" left="10px"/>
            </div>
            <div className="customize-top__cell">
              <button className="customize-top__cell-filters" onClick={() => this.props.showFiltersIfHidden()}>
                <FormattedMessage id="mobileMenu.filtersButton"/>
                {this.props.selectedFilters.length ?
                  <span className="materials-button--cart-length bold">{this.props.selectedFilters.length}</span> : null
                }
              </button>
            </div>
          </div>
          <div className="customize-back">
            <span className="customize-back__button" onClick={onBackClick}>
              <FormattedMessage id="desktop.backToCategories"/>
            </span>
          </div>
          {this.getSideBarContent()}
        </div>
        <Filters
          id="sidebar"
          searchText={this.props.searchText}
          handleSearchInputChange={this.props.handleSearchInputChange}
          childItem={this.props.activeChildNavigationItem}
          parentItem={this.props.part} />
      </div>
    );
  }

}

const mapStateToProps = (store) => {
  const {navigationCount} = store.lookState;
  return {
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    selectedFilters: store.filterState.selectedFilters,
    activeTheme: store.serverState.activeTheme,
    fabricatorData: store.fabricatorState,
    navigationCount, // update when newLayout features received
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    showFiltersIfHidden: () => dispatch(actions.showFiltersIfHidden('sidebar'))
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SidebarClass)
);
